import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from '../../../../../ui/notification';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { aiAgentApis } from '../../../../../../shared/apis/ai-agent/apis';
import { queries } from '../../../../../../shared/queries';

export default function usePatchFeedback() {
  const queryClient = useQueryClient();
  return useMutation(aiAgentApis.company.patchAiAgentFeedback, {
    onSuccess: () => {
      showSuccessNotification('변경 되었습니다.');
      queryClient.invalidateQueries({ queryKey: queries.aiAgent.aiAgentCompanies._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
